import React, { useEffect, useState } from "react";
import ReactModal from "react-modal";
import moment from "moment";
import { BrComerceApiService } from "../../services/BrComerceApiService";
import styles from "./styles.module.scss";

export const PPNConsultModal = ({ isOpen, sro, handleCloseButton }) => {
  const api = new BrComerceApiService();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [data, setData] = useState(null);

  useEffect(() => {
    if (!isOpen || !sro) return;

    const fetchPPN = async () => {
      setLoading(true);
      setError("");
      setData(null);
      try {
        const response = await api.makeHttpRequest({
          method: "GET",
          url: `tracking/ppn/${sro}`
        });
        setData(response);
      } catch (e) {
        setError(
          e?.response?.data?.message ||
          "Nao foi possivel consultar a prepostagem."
        );
      } finally {
        setLoading(false);
      }
    };

    fetchPPN();
  }, [isOpen, sro]);

  const getStatusBadgeClass = (status) => {
    if (status === "Cancelado") return styles.badgeCancelled;
    if (status === "Pre-postado") return styles.badgePrePosted;
    return styles.badgePending;
  };

  const formatDate = (date) => {
    if (!date) return "--";
    return moment(date).format("DD/MM/YYYY HH:mm");
  };

  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={handleCloseButton}
      className={styles.modal}
      style={{ overlay: { zIndex: 3, backgroundColor: "rgba(0,0,0,0.5)" } }}
    >
      <button className={styles.closeButton} onClick={handleCloseButton}>
        X
      </button>

      <div className={styles.header}>
        <h3>Consulta PPN - {sro}</h3>
      </div>

      {loading && <div className={styles.loading}>Consultando Correios...</div>}

      {error && !loading && <div className={styles.error}>{error}</div>}

      {data && !loading && (
        <div className={styles.content}>
          <div className={styles.row}>
            <label>Status atual</label>
            <span className={`${styles.badge} ${getStatusBadgeClass(data.descStatusAtual)}`}>
              {data.descStatusAtual || "--"}
            </span>
          </div>

          <div className={styles.row}>
            <label>Data/hora do status</label>
            <span>{formatDate(data.dataHoraStatusAtual)}</span>
          </div>

          {data.dceAutoGenerated && (
            <div className={styles.dceNotice}>
              DCe gerada automaticamente
              {data.chaveNFe && (
                <div>
                  <strong>Chave NF/DCe:</strong> {data.chaveNFe}
                </div>
              )}
            </div>
          )}

          {data.descStatusAtual === "Cancelado" && data.motivoCancelamento && (
            <div className={styles.row}>
              <label>Motivo do cancelamento</label>
              <span>{data.motivoCancelamento}</span>
            </div>
          )}
        </div>
      )}
    </ReactModal>
  );
};
